import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hybse-admin-update-demo-markets',
  templateUrl: './update-demo-markets.component.html',
  styleUrls: ['./update-demo-markets.component.css']
})
export class UpdateDemoMarketsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/demo-company/demo-markets/update-demo-markets/update-demo-markets.component.ts